/**
 * 栏目标题统一模板
 *
 *   [古铜金 serif 大编号]
 *   ─────────────────
 *   栏目名称 (serif 大字)
 *   栏目副标题 (灰色小字)
 *   ─────────────────
 *
 * 视觉参考：教育部、人民日报、三联书店的章节式版面
 */

export function SectionHeader({
  num,
  title,
  subtitle,
  anchor
}: {
  num: string
  title: string
  subtitle?: string
  anchor?: string
}) {
  return (
    <div id={anchor} className="mb-5 scroll-mt-20">
      <div className="font-serif text-accent-700 text-[34px] leading-none tracking-tight mb-2">
        {num}
      </div>
      <div className="h-px bg-ink-300 mb-3" />
      <h2 className="font-serif text-h2 text-ink-900 leading-tight mb-1.5">{title}</h2>
      {subtitle && (
        <p className="text-ink-600 text-sm leading-relaxed">{subtitle}</p>
      )}
      <div className="h-px bg-ink-200 mt-3" />
    </div>
  )
}
